import { frontendURL } from 'dashboard/helper/URLHelper.js';
import {
  ENGAGE_VIEW_PERMISSIONS,
  LEGACY_AGENT_ONLY_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
const EngagePageRouteView = () => import('./pages/EngagePageRouteView.vue');
const EngageTrafficPage = () => import('./pages/EngageTrafficPage.vue');
const EngageCampaignsPage = () => import('./pages/EngageCampaignsPage.vue');
const EngageGoalsPage = () => import('./pages/EngageGoalsPage.vue');
const meta = {
  permissions: {
    anyOf: [
      'administrator',
      LEGACY_AGENT_ONLY_PERMISSIONS,
      ENGAGE_VIEW_PERMISSIONS,
    ],
  },
  hideSecondarySidebar: true,
};

const engageRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/engage'),
      component: EngagePageRouteView,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'engage_traffic_index',
            params: to.params,
          }),
        },
        {
          path: 'traffic',
          name: 'engage_traffic_index',
          meta,
          component: EngageTrafficPage,
        },
        {
          path: 'campaigns',
          name: 'engage_campaigns_index',
          meta,
          component: EngageCampaignsPage,
        },
        {
          path: 'goals',
          name: 'engage_goals_index',
          meta,
          component: EngageGoalsPage,
        },
      ],
    },
  ],
};

export default engageRoutes;
